import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'fun-disclaimer-banner',
  templateUrl: './disclaimer-banner.component.html',
  styleUrls: ['./disclaimer-banner.component.scss'],
})
export class DisclaimerBannerComponent implements OnInit {

  @Input() content: string;

  safeContent: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
  }

}
